import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/auth';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import locale from 'antd/locale/ru_RU';
import 'dayjs/locale/ru';
import dayjs from 'dayjs';

dayjs.locale('ru');

const container = document.getElementById('root') as Element;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ConfigProvider locale={locale}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ConfigProvider>
  </React.StrictMode>,
);

reportWebVitals();